var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-info-wrap"},[_c('img',{staticClass:"contact-info-img",attrs:{"src":require("@/assets/images/contact_content.png")}})])
}]

export { render, staticRenderFns }